module.exports = __webpack_public_path__ + "static/media/chipanceta.3d940444.png";